'use client'

import { Client } from 'typesense'
import { type ConfigurationOptions } from 'typesense/lib/Typesense/Configuration'

const apiKey = process.env.NEXT_PUBLIC_TYPESENSE_SEARCH_API_KEY
const nodeHost = process.env.NEXT_PUBLIC_TYPESENSE_NODE_HOST

export const getTypesenseConfigurationOptions = ():
  | ConfigurationOptions
  | undefined => {
  if (!!apiKey && !!nodeHost) {
    return {
      nodes: [{ port: 443, protocol: 'https', host: nodeHost as never }],
      apiKey,
      cacheSearchResultsForSeconds: 2 * 60, // Cache search results from server. Defaults to 2 minutes. Set to 0 to disable caching.
    }
  }

  return undefined
}

export const getTypesenseClient = () => {
  const configuration = getTypesenseConfigurationOptions()
  if (configuration) {
    const client = new Client(configuration)

    return client
  }

  return undefined
}
